// logout.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "./local-storage.service";
import { ApiService } from "./api.service";
import { NotificationAlertService } from "./notification.service";
import { constants } from "../constants/constants";
import { RestaurantSelectionService } from "./restaurant-selection.service";
import { ProductService } from "../pages/merchant/tour/product.service";

@Injectable({
  providedIn: "root",
})
export class LogoutService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private localStorage: LocalStorageService,
    private api: ApiService,
    private alertService: NotificationAlertService,
    private translateService: TranslateService,
    private restaurantSelectionService: RestaurantSelectionService,
    private productService: ProductService,
  ) {
    this.getDeviceInfo();
  }

  defaultData;

  private getDeviceInfo(): void {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    this.defaultData = {
      ...this.defaultData,
      userAgent,
      platform,
      screenResolution: `${screenWidth}x${screenHeight}`,
      language: navigator.language,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      cookiesEnabled: navigator.cookieEnabled,
    };

    // Detect browser
    if (userAgent.includes("Firefox")) {
      this.defaultData["browser"] = "Firefox";
    } else if (userAgent.includes("Chrome")) {
      this.defaultData["browser"] = "Chrome";
    } else if (userAgent.includes("Safari")) {
      this.defaultData["browser"] = "Safari";
    } else if (userAgent.includes("Edge")) {
      this.defaultData["browser"] = "Edge";
    } else {
      this.defaultData["browser"] = "Unknown";
    }
  }

  async getLocationWithTimeout(timeout: number = 2000): Promise<void> {
    return new Promise((resolve) => {
      const timeoutId = setTimeout(() => {
        this.defaultData["location"] = "Not available (timeout)";
        resolve();
      }, timeout);

      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          clearTimeout(timeoutId);
          this.defaultData["location"] = [
            position.coords.latitude,
            position.coords.longitude,
          ];
          resolve();
        },
        (error) => {
          clearTimeout(timeoutId);
          console.error("Geolocation error:", error);
          this.defaultData["location"] = "Not available (error)";
          resolve();
        },
      );
    });
  }

  async completeLogout(msg: string) {
    // Get the keycloak refresh token
    const refreshToken = this.localStorage.getLocalStore("refreshtoken");
    this.defaultData["refreshToken"] = refreshToken;

    const res: any = await this.api.post("auth/logout", this.defaultData, true);
    this.restaurantSelectionService.clearRestaurantData();

    this.productService.clearState();

    await this.localStorage.clearDataFromIndexedDB();
    this.router.navigate(["/login"]);
    this.alertService.showSuccess(this.translateService.instant(msg));
    this.spinner.hide();
  }

  async getIp() {
    this.http.get(constants.GET_IP).subscribe((res: any) => {
      this.defaultData["ip"] = res.ip;
    });
  }
}
